import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, graphqlOperation, Storage, Auth } from "aws-amplify";
import { updateCandidateProfile } from "../graphql/mutations";
import awsExports from "../aws-exports"; // Adjust this import path as necessary
import { RiseLoader } from "react-spinners";
import { listAdminAddCandidateContexts } from "../graphql/queries";
import upload from "../assets/iwwa_upload.svg";
import arrow from "../assets/iwwa_upload arrow.svg";
import uploadicon from "../assets/hugeicons_file-upload.svg";
import fillRemaingField from "../assets/fill remaing field.svg";
import submit from "../assets/submit.svg";
import axios from "axios";


// Assuming awsExports is properly configured
API.configure(awsExports);
Auth.configure(awsExports);
Storage.configure(awsExports);

// const breadcrumbStyle = {
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   margin: "1rem",
//   padding: "24px",
//   borderRadius: "0px 0px 32px 32px",
//   border: "1px solid rgb(255, 255, 255)",
//   marginTop: "-6rem",
//   width: " 100%",
// };

const uploadIcon = {
  top: "70px",
  position: "relative",
};

const arrowIcon = {
  bottom: "8px",
  position: "relative",
};

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

const leftContent = {
  width: " 100%",
  padding: "8px 57px",
  border: "2px dashed #ffffff70",
  borderRadius: "8px",
  height: "55vh",
  overflowY: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "20px 0px",
  // Add the hover effect here
};

const leftContentHover = {
  border: "2px dashed #fff", // White border on hover
};

const rightContent = {
  width: " 100%",
  padding: "0px 57px",
  height: "55vh",
  overflowY: "hidden",
  display: "grid",
  gap: "15px",
  margin: "20px 0px",
};

const CandidateProfileReg = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [candidateEmail, setCandidateEmail] = useState("");
  const [file, setFile] = useState(null);
  const [arrowAnimated, setArrowAnimated] = useState(false);

  const [isHovering, setIsHovering] = useState(false); // State for hover
  const [isParsingResume, setIsParsingResume] = useState(false);
  const [parseError, setParseError] = useState(null);

  const combinedLeftStyle = { ...leftContent, ...leftContentHover }; // Combined styles

  const [resumeFile, setResumeFile] = useState({})
  const [photoFile, setPhotoFile] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const triggerFileUpload = () => {
    setArrowAnimated(true); // Trigger animation

    setTimeout(() => {
      setArrowAnimated(false); // Reset animation after a short delay
    }, 500); // Adjust delay as needed (e.g., 500ms)
  };

  // original parse code start

  // const handleFileChange = async (event, setFieldValue) => {
  //   const selectedFile = event.currentTarget.files[0];
  //   if (!selectedFile) return;
  //   setIsParsingResume(true);
  //   setParseError(null);
  //   try {
  //     const formData = new FormData();
  //     formData.append("resume", selectedFile);
  //     const response = await axios.post(
  //       "https://resumeai-budueug9cybsgbaj.canadacentral-01.azurewebsites.net/upload_resume",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     console.log(response);
  //     // Map API response to form fields
  //     const parsedData = response.data;
  //     const fieldMappings = {
  //       name: "fullName",
  //       currentCity: "currentCity",
  //       workStatus: "workStatus",
  //       keySkills: "keySkills",
  //       phone: "mobileNumber",
  //       email: "email",
  //       github: "githubURL",
  //       linkedin: "linkedinURL",
  //       description: "description",
  //     };
  //     // Update form fields with parsed data
  //     Object.entries(fieldMappings).forEach(([apiField, formField]) => {
  //       if (parsedData[apiField]) {
  //         setFieldValue(formField, parsedData[apiField]);
  //       }
  //       console.log("zzzzzzzzzzzzzzz", apiField);
  //       console.log("xxxxxxxxxxxxxxxxxxxx", formField);
  //     });
  //     console.log("Resume parsed successfully:", parsedData);
  //   } catch (error) {
  //     console.error("Resume parsing failed:", error);
  //     setParseError(
  //       "Failed to parse resume. Please fill in the details manually."
  //     );
  //   } finally {
  //     setIsParsingResume(false);
  //   }
  //   setFieldValue("resume", selectedFile); // Set file value manually

  //   setFile(selectedFile.name); // Assuming setFile is a function to set file state
  // };


  // original parse code end

  const handleResumeUpload = async (event) => {
    const selectedFile = event.target.files[0];
    setResumeFile(event.target.files[0])
    if (!selectedFile) return;

    setIsParsingResume(true);
    setParseError(null);

    try {
      const formData = new FormData();
      formData.append("resume", selectedFile);

      const response = await axios.post("https://resumeai-budueug9cybsgbaj.canadacentral-01.azurewebsites.net/upload_resume", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("Resume upload response:", response);

      const parsedData = response.data;

      // Mapping API fields to your form state
      const updatedFields = {
        fullName: parsedData.name || "",
        currentCity: parsedData.currentCity || "",
        // workStatus: parsedData.workStatus || "",
        keySkills: parsedData.keySkills || "",
        mobileNumber: parsedData.phonenumber || "",
        email: parsedData.email || "",
        githubURL: parsedData.github || "",
        linkedinURL: parsedData.linkedin || "",
        description: parsedData.description || "",
        address: parsedData.address || "",
        // roleApplyFor: parsedData.roleappliedfor || "",
        roleApplyFor: parsedData.roleappliedfor !== "Not specified" ? parsedData.roleappliedfor || "" : "",
        workStatus: parsedData.workstatus !== "Not specified" ? parsedData.workstatus || "" : "",
      };

      // Update form state with parsed data
      setFormData((prev) => ({ ...prev, ...updatedFields }));

      console.log("Resume parsed successfully:", parsedData);
    } catch (error) {
      console.error("Resume parsing failed:", error);
      setParseError("Failed to parse resume. Please fill in the details manually.");
    } finally {
      setIsParsingResume(false);
    }

    setFile(selectedFile.name);
  };


  const [formData, setFormData] = useState({
    id: localStorage.getItem("candidateProfileId") || "", // Retrieve ID from local storage
    fullName: "",
    gender: "",
    mobileNumber: "",
    description: "",
    matchedPercentage: 0,
    workStatus: "",
    currentCity: "",
    educationDetails: "",
    keySkills: "",
    workPreference: "",
    preferredSalary: "",
    photo: null,
    resume: null,
    photoURL: "",
    resumeURL: "",
    roleApplyFor: "", // New field
    address: "", // New field,
    workMode: [],
    workCategory: [],
    githubURL: "",
    linkedinURL: "",
  });

  const candidateProfileEmailID = localStorage.getItem(
    "candidateProfileEmailID"
  );

  useEffect(() => {
    // Retrieve the candidateProfileEmailID from local storage
    const candidateProfileEmailID = localStorage.getItem(
      "candidateProfileEmailID"
    );

    // Update the content of the span element with the candidateProfileEmailID
    setCandidateEmail(candidateProfileEmailID);
  }, []);
  const [candidateProfileView, setCandidateProfileView] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.graphql(
          graphqlOperation(listAdminAddCandidateContexts)
        );
        const items = response.data.listAdminAddCandidateContexts.items;

        // Check if candidateEmail exists in any of the profiles
        const foundProfile = items.some(
          (profile) => profile.candidateEmail === candidateEmail
        );

        // Set candidateProfile based on whether the candidateEmail exists in the profiles
        setCandidateProfileView(foundProfile);
      } catch (error) {
        console.error("Error fetching candidate data:", error);
      }
    };

    // Fetch data only if candidateEmail exists
    if (candidateEmail) {
      fetchData();
    }
  }, [candidateEmail]);




  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setPhotoFile(file);
  };

  const handleCheckboxChange = (e, fieldName) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [fieldName]: checked
        ? [...prev[fieldName], value] // Add value if checked
        : prev[fieldName].filter((item) => item !== value), // Remove if unchecked
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleSubmit = async (event) => {

    event.preventDefault(); // Prevent form submission

    setIsSubmitting(true)

    if (
      !formData.fullName.trim() ||
      !formData.roleApplyFor.trim() ||
      !formData.workStatus.trim() ||
      !formData.mobileNumber.trim() ||
      !resumeFile.name // Ensure resume file is uploaded
    ) {
      // alert("Please fill all required fields.");
      alert("* Required field");
      return; // Stop form submission
    }



  // Use stage bucket details from aws-exports.js
  const bucketName = awsExports.aws_user_files_s3_bucket;
  const bucketRegion = awsExports.aws_user_files_s3_bucket_region;
  const publicBaseUrl = `https://${bucketName}.s3.${bucketRegion}.amazonaws.com/public`;


    if (photoFile.name) {
      try {
        const { key: photoKey } = await Storage.put(
          `${Date.now()}_${photoFile.name}`,
          photoFile,
          { contentType: "image/*" } // or candidateProfile.photo.type for more specific types
        );
  formData.photoURL = `${publicBaseUrl}/${photoKey}`;
      } catch (error) {
        console.error("Error uploading photo:", error);
        return;
      }
    }


    if (resumeFile) {
      try {
        const { key: resumeKey } = await Storage.put(
          `${Date.now()}_${resumeFile.name}`,
          resumeFile,
          { contentType: "application/pdf" } // or candidateProfile.resume.type for more specific types
        );
  formData.resumeURL = `${publicBaseUrl}/${resumeKey}`;
      } catch (error) {
        console.error("Error uploading resume:", error);
        return;
      }
    }


    const mutationInput = {
      id: localStorage.getItem("candidateProfileId") || "", // Retrieve ID from local storage
      fullName: formData.fullName,
      gender: formData.gender,
      mobileNumber: formData.mobileNumber,
      description: formData.description,
      matchedPercentage: parseFloat(formData.matchedPercentage),
      workStatus: formData.workStatus,
      currentCity: formData.currentCity,
      educationDetails: formData.educationDetails,
      keySkills: formData.keySkills,
      workPreference: formData.workPreference,
      preferredSalary: parseFloat(formData.preferredSalary),
      photoURL: formData.photoURL,
      resumeURL: formData.resumeURL,
      roleApplyFor: formData.roleApplyFor, // New field
      address: formData.address, // New field
      workMode: formData.workMode,
      workCategory: formData.workCategory,
      githubURL: formData.githubURL,
      linkedinURL: formData.linkedinURL,
    };


    const response = await API.graphql(
      graphqlOperation(updateCandidateProfile, { input: mutationInput })
    );


    if (candidateProfileView) {
      navigate("/CandidateDashboard"); // Navigate to CandidateResumeDetails
    } else {
      navigate("/candidateSchedule"); // Navigate to candidateSchedule
    }
  }


  return (
    <>
      <style>
        {`
          .mainContent {
            width: 100%;
            padding: 8px 20px;
            border: 1px solid #fff;
            border-radius: 8px;
            margin: 20px 0px;
            display: grid;
            grid-template-columns: 1fr;
            gap: 20px;
          }
  @media (min-width: 800px) {
            .mainContent {
              padding: 8px 57px;
              display: flex;
              grid-template-columns: none;
              gap: 0;
            }
          }
        `}
      </style>
      <div
        className="min-h-screen  text-white flex justify-center items-center"
      // style={{ backgroundColor: "#101222" }}
      >
        <div
          className="container mx-auto px-4"
          style={{
            backgroundColor:
              "linear-gradient(120deg, rgb(102, 126, 234) 0%, rgb(136, 89, 184) 100%);",
          }}
        >
          <div
            className=" rounded shadow-lg p-6 md:p-8"
            style={{
              margin: "50px",
              // backgroundColor: "#1a1934",
              color: "#ffffff",
              width: "-webkit-fill-available",
              height: "inherit",
            }}
          >
            {/* Progress Steps */}
            {/* <div
            className="flex justify-between items-center mb-8 "
            style={breadcrumbStyle}
          >
            <div
              className={`w-12 h-12 rounded-full d-flex items-center justify-center border-2 border-white border-radius-10 bg-white 
              
              `}
            >
             
              <img
                src={fillRemaingField}
                alt="Upload Icon"
                className="w-6 h-6"
              />
            </div>
            <div
              className="flex-1 h-px bg-gray-300 mx-4 border-dashed border-1 transition-colors  "
              style={{
                backgroundColor: "transparent",
                borderDash: "25px 10px",
              }}
            />
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center border-2 border-white border-radius-10
              `}
            >
              <img src={uploadicon} alt="Upload Icon" className="w-6 h-6" />
            </div>
            <div
              className="flex-1 h-px bg-gray-300 mx-4 border-dashed border-1 transition-colors "
              style={{ backgroundColor: "transparent" }}
            />
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center border-2 border-white border-radius-10
            `}
            >
              <img src={submit} alt="Upload Icon" className="w-6 h-6" />
            </div>
          </div> */}
            <h1 style={{ textAlign: "center" }}>Registration Form</h1>
            {loading ? (
              <div className="flex justify-center items-center">
                <RiseLoader
                  color={"#ffffff"}
                  loading={loading}
                  css={override}
                  size={40}
                  aria-label="Loading Spinner"
                />
              </div>
            ) : (
              <form>
                <div className="mainContent">
                  {/* original parse code start */}
                  {/* <div
                    className="relative"
                    style={isHovering ? combinedLeftStyle : leftContent}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                  >
                    {" "}
                    <label
                      htmlFor="resume"
                      className="cursor-pointer flex items-center justify-center h-full"
                      onClick={triggerFileUpload}
                    >
                      {" "}
                      <div className="flex flex-col items-center">
                        {" "}
                        <div>
                          <img
                            src={upload}
                            alt="upload"
                            className="w-20 h-20"
                            style={uploadIcon}
                          />
                          <img
                            src={arrow}
                            alt="upload"
                            className={`w-20 h-20 transition-all duration-500 ${arrowAnimated ? "translate-y-[-10px]" : ""
                              }`}
                            style={arrowIcon}
                          />
                        </div>
                        <span className="text-white text-lg font-semibold mb-2">
                          Upload Resume
                        </span>
                        <span className="text-white text-sm">
                          *Note : Upload document in pdf, text, etc
                        </span>
                        {file && (
                          <p
                            className=" text-sm mt-2"
                            style={{ color: "rgb(130 255 177)" }}
                          >
                            {file}
                          </p>
                        )}
                        {isParsingResume && <div>Parsing resume...</div>}
                      </div>
                    </label>
                    <input
                      type="file"
                      name="resume"
                      id="resume"
                      accept=".pdf"
                      className="hidden"
                    />
                    {parseError && (
                      <div className="text-red-500">{parseError}</div>
                    )}
                  </div> */}

                  {/* original parse code end */}

                  <div
                    className="relative"
                    style={isHovering ? combinedLeftStyle : leftContent}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                  >
                    <label
                      htmlFor="resume"
                      className="cursor-pointer flex items-center justify-center h-full"
                      onClick={triggerFileUpload}
                    >
                      <div className="flex flex-col items-center">
                        <div>
                          <img src={upload} alt="upload" className="w-20 h-20" style={uploadIcon} />
                          <img
                            src={arrow}
                            alt="upload"
                            className={`w-20 h-20 transition-all duration-500 ${arrowAnimated ? "translate-y-[-10px]" : ""
                              }`}
                            style={arrowIcon}
                          />
                        </div>
                        <span className="text-white text-lg font-semibold mb-2">
                          Upload Resume
                        </span>
                        <span className="text-white text-sm">
                          *Note: Upload document in pdf, text, etc.
                        </span>
                        {file && (
                          <p className="text-sm mt-2" style={{ color: "rgb(130 255 177)" }}>
                            {file}
                          </p>
                        )}
                        {isParsingResume && <div>Parsing resume...</div>}
                      </div>
                    </label>

                    <input
                      type="file"
                      name="resume"
                      id="resume"
                      accept=".pdf"
                      onChange={handleResumeUpload}
                      className="hidden"
                    />

                    {parseError && <div className="text-red-500">{parseError}</div>}
                  </div>




                  <div style={rightContent}
                    className="relative h-[600px] overflow-y-auto rounded-md"
                  >
                    <div>
                      <label
                        htmlFor="fullName"
                        className="block text-sm font-medium "
                      >
                        Full Name *
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        placeholder="e.g. Chris Johnson"
                        value={formData.fullName}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                        required
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="gender"
                        className="block text-sm font-medium "
                      >
                        Gender
                      </label>
                      <select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        className="select select-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      >
                        <option selected style={{ color: "#000" }}>
                          Gender
                        </option>
                        <option value="male" style={{ color: "#000" }}>
                          Male
                        </option>
                        <option value="female" style={{ color: "#000" }}>
                          Female
                        </option>
                        <option value="other" style={{ color: "#000" }}>
                          Other
                        </option>
                      </select>
                    </div>
                    <div>
                      <label
                        htmlFor="mobileNumber"
                        className="block text-sm font-medium "
                      >
                        Mobile Number *
                      </label>
                      <input
                        type="text"
                        name="mobileNumber"
                        placeholder="e.g. 9561471059"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="description"
                        className="block text-sm font-medium "
                      >
                        Description
                      </label>
                      <textarea
                        name="description"
                        id="description"
                        placeholder="Brief description about yourself"
                        value={formData.description}
                        onChange={handleChange}
                        className="mt-1 block w-full p-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      ></textarea>
                    </div>
                    <div>
                      <label
                        htmlFor="workStatus"
                        className="block text-sm font-medium "
                      >
                        Work Status *
                      </label>
                      <input
                        type="text"
                        name="workStatus"
                        placeholder="e.g. fresher or experience "
                        value={formData.workStatus}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                        required
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="roleApplyFor"
                        className="block text-sm font-medium"
                      >
                        Role Apply For *
                      </label>
                      <input
                        type="text"
                        name="roleApplyFor"
                        placeholder="eg. junior / senior data scientist"
                        value={formData.roleApplyFor}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                        required
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="currentCity"
                        className="block text-sm font-medium "
                      >
                        Current City
                      </label>
                      <input
                        type="text"
                        name="currentCity"
                        placeholder="e.g. Pune"
                        value={formData.currentCity}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      />
                    </div>
                    {/* <div>
                      <label
                        htmlFor="educationDetails"
                        className="block text-sm font-medium "
                      >
                        Education Details
                      </label>
                      <textarea
                        name="educationDetails"
                        placeholder="e.g. give the highest qualification"
                        value={formData.educationDetails}
                        onChange={handleChange}
                        className="textarea textarea-bordered w-full p-2 rounded h-24 md:col-span-2"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      ></textarea>
                    </div>
                    <div>
                      <label
                        htmlFor="keySkills"
                        className="block text-sm font-medium "
                      >
                        Key Skills
                      </label>
                      <input
                        type="text"
                        name="keySkills"
                        placeholder="separated by comma e.g. (ReactJS, NextJS)"
                        value={formData.keySkills}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="workPreference"
                        className="block text-sm font-medium "
                      >
                        Work Preference
                      </label>
                      <input
                        type="text"
                        name="workPreference"
                        placeholder="prefer choice to work location e.g .(Pune)"
                        value={formData.workPreference}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="preferredSalary"
                        className="block text-sm font-medium "
                      >
                        Preferred Salary
                      </label>
                      <input
                        type="text"
                        name="preferredSalary"
                        placeholder="expected salary e.g. (500000)"
                        value={formData.preferredSalary}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="address"
                        className="block text-sm font-medium"
                      >
                        Address *
                      </label>
                      <input
                        type="text"
                        name="address"
                        placeholder="e.g. hinjewadi phase 1 wakad pune maharashtra"
                        value={formData.address}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      />
                    </div>
                    <div className="">
                      <label className="block text-sm font-medium ">
                        Work Mode *
                      </label>
                      <div className="flex flex-wrap p-2 border border-white rounded-md">
                        {["Remote", "Hybrid", "Office"].map((mode) => (
                          <div
                            key={mode}
                            className="flex items-center mr-4 mb-2"
                          >
                            <input
                              type="checkbox"
                              id={mode}
                              name="workMode"
                              value={mode}
                              onChange={(e) => handleCheckboxChange(e, "workMode")}
                              checked={formData.workMode.includes(mode)}
                              className="mr-2"
                            />
                            <label htmlFor={mode} className="text-sm ">
                              {mode}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium">
                        Work Category *
                      </label>
                      <div className="flex flex-wrap p-2 border border-white rounded-md ">
                        {["Internship", "FullTime", "PartTime"].map(
                          (category) => (
                            <div
                              key={category}
                              className="flex items-center mr-4 mb-2"
                            >
                              <input
                                type="checkbox"
                                id={category}
                                name="workCategory"
                                value={category}
                                onChange={(e) => handleCheckboxChange(e, "workCategory")}
                                checked={formData.workCategory.includes(category)}
                                className="mr-2"
                              />
                              <label
                                htmlFor={category}
                                className="text-sm "
                              >
                                {category}
                              </label>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="githubUrl"
                        className="block text-sm font-medium"
                      >
                        GitHub URL
                      </label>
                      <input
                        type="text"
                        name="githubURL"
                        placeholder="Enter your GitHub URL"
                        value={formData.githubURL}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded bg-transparent border-1"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="linkedinUrl"
                        className="block text-sm font-medium"
                      >
                        LinkedIn URL
                      </label>
                      <input
                        type="text"
                        name="linkedinURL"
                        placeholder="www.linkedin.com/in/John-Smith256"
                        value={formData.linkedinURL}
                        onChange={handleChange}
                        className="input input-bordered w-full p-2 rounded bg-transparent border-1"
                      />
                    </div> */}
                    <div>
                      <label
                        htmlFor="photo"
                        className="block text-sm font-medium "
                      >
                        Candidate Photo
                      </label>
                      <input
                        type="file"
                        name="photo"
                        id="photo"
                        accept="image/*"
                        // onChange={handleChange}
                        // onChange={handlePhotoChange}
                        // onChange={(e) =>
                        //   setFieldValue(
                        //     "handlePhotoChange",
                        //     e.target.handlePhotoChange
                        //   )
                        // }
                        onChange={handlePhotoChange}
                        className="mt-1 block w-full p-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #fff",
                        }}
                      />
                      {/* {touched.photo && errors.photo ? (
                          <p className="text-sm text-red-700">{errors.photo}</p>
                        ) : null} */}
                    </div>
                  </div>
                </div>
                <div className="md:col-span-2 flex justify-end">
                  <button
                    type="cancel"
                    className="w-full md:w-auto  hover:bg-blue-700 text-white font-medium py-2 px-4 mr-4 rounded"
                    style={{
                      backgroundColor: "transperant",
                      border: "1px solid #9900ff",
                      color: "#9900ff",
                    }}
                    onClick={() => navigate("/CandidateDashboard")}
                  // onClick={() => navigate("/")}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="w-full md:w-auto hover:bg-blue-700 font-medium py-2 px-4 rounded"
                    style={{
                      backgroundColor: "#9900ff",
                      border: "1px solid #9900ff",
                      color: "#fff",
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateProfileReg;
